





















import Component, { mixins } from "vue-class-component";
import CodeDial from "@/ui-component/CodeDial.vue";
import ErrorMixin from "@/mixins/errorMixins";

@Component({
  components: { CodeDial },
})
export default class MiseEnRoute extends mixins(ErrorMixin) {
  public validated = false;

  public validateCode(evt: any) {
    this.validated = evt;
  }

  public startItClean() {
    this.$store.dispatch("login/setLoading", true);
    // console.log("mise en route");
    this.$store.dispatch("bdd/miseEnRoute").then(
      (data: any) => {
        this.setSuccess(this.$t("SuccessMiseEnRoute").toString());
        this.$store.dispatch("login/setLoading", false);
      },
      (error: any) => {
        this.setErrorFromTxt(error.toString());
        this.$store.dispatch("login/setLoading", false);
      }
    );
  }
}
